<template>
  <section class="white">
    <v-container grid-list-xl>
      <v-row>
        <news-item :data="item" v-for="item in newsStore.latest" :key="item.id"></news-item>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapStores } from 'pinia';
import { useNewsStore } from '../../../stores/NewsStore';
import NewsItem from '../../../components/common/NewsItemComponent.vue';

export default {
  components: { NewsItem },
  computed: {
    ...mapStores(useNewsStore),
  },

  created() {
    this.newsStore.loadLatest();
  }
};
</script>
